module.exports = __webpack_public_path__ + "static/media/icon_feijiechuwuganzhi_wap.47bdfc7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/icon_feijiechuwuganzhi_wap.svg
// module id = 498
// module chunks = 0